import React from 'react';
import { Moment } from 'moment-timezone';

import FormInputField from '@modules/common/components/Field/FormInputField';
import DropdownField from '@modules/common/components/Field/DropdownField';
import BaseForm from '@modules/common/components/BaseForm';

import { OAuthFlow } from '../../../components/types/oauth-client';
import { SUPPORTED_OAUTH_FLOWS } from '../const';
import SPASettings from '../components/SPASettings';
import ExpiryDateSelector from '../components/ExpiryDateSelector';

const EMPTY_CLIENT_NAME = '';

type Props = {
  isLoading: boolean;
  selectedOAuthFlow?: OAuthFlow;
  clientName?: string;
  expiryDate?: Moment;
  expirationDisabled: boolean;
  setSelectedOAuthFlow: (flow: OAuthFlow) => void;
  setClientName: (name: string) => void;
  setExpiryDate: (date: Moment | undefined) => void;
  setExpirationDisabled?: (isDisabled: boolean) => void;
  expiryDateDisabled?: boolean;
  supportedFlowDisabled?: boolean;
  allowedOriginDomains?: string[];
  setAllowedOriginDomains?: (origins?: string[]) => void;
  hasAcceptedSPARisk?: boolean;
  setHasAcceptedSPARisk?: (value: boolean) => void;
  hasAcceptedExpiryRisk?: boolean;
  setHasAcceptedExpiryRisk?: (value: boolean) => void;
  isSetupForSPA?: boolean;
  setIsSetupForSPA?: (value: boolean) => void;
  isEditingSPASettings?: boolean;
};

function ClientForm({
  isLoading,
  selectedOAuthFlow,
  setSelectedOAuthFlow,
  clientName = EMPTY_CLIENT_NAME,
  setClientName,
  expiryDate,
  setExpiryDate,
  expirationDisabled,
  setExpirationDisabled,
  expiryDateDisabled = false,
  supportedFlowDisabled = false,
  isSetupForSPA = false,
  setIsSetupForSPA,
  allowedOriginDomains,
  setAllowedOriginDomains,
  hasAcceptedSPARisk,
  setHasAcceptedSPARisk,
  hasAcceptedExpiryRisk,
  setHasAcceptedExpiryRisk,
  isEditingSPASettings = false,
}: Props) {
  return (
    <BaseForm>
      <FormInputField
        fieldName="name"
        label="Client name:"
        value={clientName}
        fieldLabel="Client name"
        onChange={(_, { value }) => setClientName(value)}
        required
        disabled={isLoading}
      />
      <DropdownField
        label="Supported flow:"
        value={selectedOAuthFlow}
        options={SUPPORTED_OAUTH_FLOWS}
        onChange={(_, { value }) => setSelectedOAuthFlow(value as OAuthFlow)}
        disabled={isLoading || supportedFlowDisabled}
      />
      <ExpiryDateSelector
        isLoading={isLoading}
        expiryDate={expiryDate}
        setExpiryDate={setExpiryDate}
        expirationDisabled={expirationDisabled}
        setExpirationDisabled={setExpirationDisabled}
        hasAcceptedExpiryRisk={hasAcceptedExpiryRisk}
        setHasAcceptedExpiryRisk={setHasAcceptedExpiryRisk}
        readonly={expiryDateDisabled}
      />
      {setAllowedOriginDomains && (
        <SPASettings
          isSetupForSPA={isSetupForSPA}
          setIsSetupForSPA={setIsSetupForSPA}
          allowedOriginDomains={allowedOriginDomains}
          setAllowedOriginDomains={setAllowedOriginDomains}
          hasAcceptedSPARisk={hasAcceptedSPARisk}
          setHasAcceptedSPARisk={setHasAcceptedSPARisk}
          isEditing={isEditingSPASettings}
        />
      )}
    </BaseForm>
  );
}

export default ClientForm;
